/*=========================================================================================
  File Name: i18nCommon.js
  Description: File đa ngôn ngữ chung
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
	Author: NCThanh1
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	Delcaration: 'tờ khai',
	TooltipCheckboxMulti: 'Thực hiện hàng loạt',
	Question: 'Hướng dẫn xử lý lỗi thường gặp',
	LinkApp: 'mtaxapp.misa.vn',
	TimerSyncConnectTaxixion: 'Tự động đồng bộ sau',
	ExtendFeature: 'Tính năng mở rộng',
	DeleteAllWarning: 'Bạn có thực sự muốn xóa tất cả các dòng đã nhập không?',
	AddDetail: 'Thêm dòng',
	DeleteAll: 'Xóa hết dòng',
	Cancel: 'Hủy',
	Save: 'Cất',
	Save2: 'Lưu',
	SavePrint: 'Cất và In',
	Print: 'In',
	Utilize: 'Tiện ích',
	DisplayAccount: 'Hiển thị tài khoản',
	SaveClose: 'Cất và Đóng',
	Feature: 'Chức năng',
	Filter: 'Lọc',
	FilterTitle: 'Bộ lọc',
	Index: 'STT',
	LearnMore: 'Tìm hiểu thêm',
	FilterReport: 'Lọc báo cáo',
	UnFilter: 'Đặt lại',
	AdvanceFilter: 'Lọc nâng cao',
	Export: 'Xuất khẩu',
	View: 'Xem',
	ViewDetail: 'Xem chi tiết',
	Replication: 'Nhân bản',
	Delete: 'Xóa',
	ChooseReport: 'Chọn báo cáo',
	FromDate: 'Từ ngày',
	ToDate: 'Đến ngày',
	FromMonth: 'Từ tháng',
	ToMonth: 'Đến tháng',
	FromQuarter: 'Từ quý',
	ToQuarter: 'Đến quý',
	FromYear: 'Từ năm',
	ToYear: 'Đến năm',
	Agree: 'Đồng ý',
	Implement: 'Thực hiện',
	Total: 'Cộng',
	Add: 'Thêm',
	Finish: 'Hoàn thành',
	Back: 'Quay lại',
	SaveAdd: 'Cất và Thêm',
	From: 'Từ',
	To: 'Đến',
	to: 'đến',
	Become: 'thành',
	Edit: 'Sửa',
	ClearCondition: 'Xóa điều kiện',
	Report: 'Báo cáo',
	Account: 'Tài khoản',
	Choose: 'Chọn',
	DeleteTrash: 'Xóa bỏ',
	ReportSpam: 'Báo cáo spam',
	NotSpam: 'Không phải spam',
	Use: 'Sử dụng',
	StopUsing: 'Ngừng sử dụng',
	Menu: 'Tất cả danh mục',
	CollapseTooltip: 'Thu gọn',
	ExpandTooltip: 'Mở rộng',
	Term: 'Kỳ',
	Yes: 'Có',
	No: 'Không',
	Show: 'Có hiển thị',
	NotShow: 'Không hiển thị',
	Close: 'Đóng',
	Help: 'Giúp',
	RecentView: 'Xem gần đây',
	Description: 'Diễn giải',
	Noted: 'Ghi chú',
	NotedMany: 'Ghi chú hàng loạt',
	ClosePop: 'Hủy',
	Search: 'Tìm kiếm',
	SearchDot: 'Tìm kiếm...',
	Here: 'tại đây',
	SeeHere: 'Xem tại đây',
	All: 'Tất cả',
	NoInformation: 'Không có thông tin',
	Times: 'Thời gian',
	Status: 'Tình trạng',
	Branch: 'Chi nhánh',
	Of: 'của',
	NotFound: 'Không tìm thấy.',
	Procedure: 'Quy trình',
	UnderConstruction: 'Tính năng đang trong quá trình phát triển',
	SearchFor: 'Tìm theo',
	Value: 'Giá trị',
	UpdateStatus: 'Cập nhật trạng thái',
	Update: 'Cập nhật',
	And: 'Và',
	Or: 'Hoặc',
	Contain: 'Chứa',
	NotContain: 'Không chứa',
	StartsWith: 'Bắt đầu với',
	EndsWith: 'Kết thúc với',
	ClearFilter: 'Xóa bộ lọc',
	ChooseFilterCondition: 'Chọn điều kiện lọc',
	ShowMore: 'Xem thêm',
	ShowLess: 'Thu gọn',
	Refresh: 'Tải lại',
	RePrint: 'In lại',
	Detail: 'Chi tiết',
	EnterKeySearch: 'Nhập từ khóa tìm kiếm',
	Empty: 'Trống',
	NotEmpty: 'Không trống',
	Equal: 'Bằng',
	TotalSum: 'Tổng cộng',
	AddTaxPaper: 'Nộp Giấy nộp tiền',
	Draft: 'Lưu bản nháp',
	Next: 'Tiếp theo',
	Input: 'Nhập',
	CancelRequest: 'Có lỗi xảy ra trong quá trình xử lý',
	Date: 'Ngày',
	Month: 'Tháng',
	Year: 'Năm',
	Quarter: 'Quý',
	Stage: 'Kỳ',
	TypeTaxPeriod: 'Loại kỳ tính thuế',
	ChangePopupClose: 'Dữ liệu chưa được lưu.</br> Bạn có chắc chắn muốn hủy bỏ?',
	CreatedDate: 'Ngày nộp',
	noData: 'Không có bản ghi nào',
	SaveDraftSuccess: 'Lưu nháp thành công',
	BackHome: 'Quay lại trang chủ',
	Unauthorized: 'Bạn không có quyền truy cập',
	ConfigLayout: 'Thiết lập bảng',
	ConfigColumn: 'Danh sách cột hiển thị',
	NoDataFilter: 'Không tìm thấy kết quả nào',
	NoOrganization: 'Không có đơn vị nào',
	ErrorCertificate:
		'Chứng thư số không đúng. Bạn phải dùng chứng thư số đã đăng ký sử dụng dịch vụ nộp thuế điện tử để ký.',
	ErrorFormal: 'Đã có lỗi xảy ra. Vui lòng kiểm tra lại.',
	CheckAgain: 'Kiểm tra lại',
	UpdateCostType: 'Cập nhật định mức chi phí',
	AcceptResultNote1: 'Chương trình chỉ lấy lên các tiêu chí được phép chấp nhận và đã được phân quyền làm việc.',
	AcceptResultNote2: 'Chọn tiêu chí bạn muốn chấp nhận hợp lệ và nhấn “Đồng ý”.',
	AcceptResultCol1: 'Tên tiêu chí',
	AcceptResultCol2: 'Ảnh hưởng đến kết quả kiểm tra',
	AcceptCheckingResult: 'Chấp nhận hợp lệ',
	PrintCheckingResult: 'In kết quả kiểm tra',
	Download: 'Tải xuống',
	UploadXml: 'Tải lên file xml',
	ReSubmit: 'Nộp lại',
	ViewNotification: 'Xem thông báo',
	OnCapsLock: 'Đang bật Caps Lock',
	NoFilterData: 'Không tìm thấy dữ liệu',
	GetInfo: 'Lấy thông tin',
	NotAuthorized: 'Bạn không có quyền thực hiện tính năng này!',
	PageNotFound: 'Oops! Không tìm thấy trang',
	UrlChangeL: 'Đường dẫn đang truy cập đã bị thay đổi hoặc không tồn tại.',
	InternalServer: 'Oops! Đã có lỗi xảy ra',
	InternalServerText: 'Vui lòng liên hệ Quản trị hệ thống để được trợ giúp',
	SignIn: 'Đăng nhập',
	Code: 'Mã',
	Name: 'Tên',
	NameTaxAgentControl: 'Tên cơ quan thuế quản lý',
	NameTaxAgentPayer: 'Tên cơ quan quản lý thu',
	BuyNow: 'Mua ngay',
	BuyMore: 'Mua thêm',
	Accept: 'Xác nhận',
	CompanyMisa: 'Công ty cổ phần MISA',
	BankACB: 'Hội Sở ngân hàng TMCP Á Châu',
	ClickToCopy: 'Nhấn để sao chép',
	Inactive: 'Ngừng hoạt động',
	Active: 'Đang hoạt động',
	Forward: 'Chuyển tiếp',
	SendMail: 'Gửi thư',
	Restore: 'Khôi phục',
	AcceptInvoice: 'Duyệt',
	RejectInvoice: 'Không duyệt',
	SendMailSeller: 'Gửi phản hồi cho NCC',
	SendMailMisa: 'Gửi cho MISA',
	DeleteForever: 'Xóa vĩnh viễn',
	InputSearch: 'Nhập để tìm kiếm',
	Default: 'Ngầm định',
	RestoreDefaults: 'Lấy lại mặc định',
	RestoreFilterDefaults: 'Bộ lọc mặc định',
	AddNewStick: 'Tạo nhãn mới',
	AddNewStick2: 'Thêm nhãn',
	Upload: 'Tải lên',
	Send: 'Gửi',
	Connect: 'Kết nối',
	DisConnect: 'Ngắt kết nối',
	ConnectNow: 'Kết nối ngay',
	EnterInvoice: 'Nhập liệu hóa đơn',
	UploadExtensionSupport: 'xml,inv,pdf,rar,zip,tar,gzip,7z,jpg,jpeg,jfif,pjpeg,pjp,png,apng,gif,bmp,avif,svg|webp',
	UploadExtensionAccept:
		'.xml,.inv,.pdf,.rar,.zip,.tar,.gzip,.7z,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.apng,.gif,.bmp,.avif,.svg,.webp',
	Accounted: 'Đánh dấu đã hạch toán',
	UnAccounted: 'Đánh dấu chưa hạch toán',
	MaxLengthFileUpload: 'Dung lượng tải lên không được vượt quá 5Mb',
	MaxLengthAllFileUpload: 'Dung lượng file tải lên không được vượt quá 5MB/1 lần và tổng lưu trữ không quá 10MB.',
	Notice: 'Lưu ý',
	FileSizeTooLarge: 'Dung lượng file quá lớn',
	ExistEmail: 'Email đã tồn tại',
	MoveInvoice: 'Điều chuyển',
	MoveReceipt: 'Điều chuyển',
	MoveDeclaration: 'Điều chuyển',
	NotSure: 'Đang kiểm tra',
	Replace: 'Thay thế',
	AttachFile: 'Thêm tệp đính kèm',
	PaymentInvoice: 'Đánh dấu thanh toán',
	MoveOutInvoice: 'Điều chuyển',
	UploadOutInvoiceExtensionSupport: 'xml,inv,rar,zip,tar,gzip,7z',
	UploadOutInvoiceExtensionAccept: '.xml,.inv,.rar,.zip,.tar,.gzip,.7z',
	UploadDeclarationExtensionSupport: 'xml,inv,rar,zip,tar,gzip,7z,xls,xlsx',
	UploadDeclarationExtensionAccept: '.xml,.inv,.rar,.zip,.tar,.gzip,.7z,.xls,.xlsx',
	NoOrgSetting: 'Chưa có chi nhánh/phòng ban được chọn',
	NoSupplier: 'Không có nhà cung cấp nào',
	NoEmailSupplier: 'Không có email, nhà cung cấp nào',
	Success: 'Thành công',
	Process: 'Đang thực hiện...',
	ErrorNeedContaxMisa: 'Có lỗi xảy ra vui lòng liên hệ MISA để được trợ giúp',
	ErrorOccurred: 'Có lỗi xảy ra. Vui lòng kết nối sau hoặc liên hệ với MISA để được hỗ trợ.',
	ErrorProcessNeedContactMisa: 'Có lỗi xảy ra trong quá trình xử lý. Vui lòng liên hệ MISA',
	InTotal: 'trong số',
	DownloadAll: 'Tải tất cả',
	Company: 'Công ty',
	Department: 'Phòng ban',
	Branch: 'Chi nhánh',
	SystemPendingToCheck: 'Hệ thống đang xử lý và sẽ trả về kết quả sau ít phút',
	SystemSyncAgain: 'Hệ thống đang đồng bộ lại và sẽ trả về kết quả sau ít phút',
	InvoiceNo: 'Số hóa đơn',
	ReceiptNo: 'Số biên lai',
	InvoiceTemplateNo: 'Mẫu số hóa đơn',
	SymbolInvoice: 'Ký hiệu hóa đơn',
	AlertHaveSomeWrongAfterCheckInvoice:
		'Sau khi kiểm tra hóa đơn, chúng tôi nhận thấy các thông tin sau chưa chính xác. Đề nghị quý công ty xem xét lại',
	Goodbye: 'Trân trọng kính chào',
	Dear: 'Kính gửi',
	ErrorCannotReadInvoiceFromEmail: `Hiện tại hệ thống chưa nhận diện được hóa
	đơn từ email này. Vui lòng tải về Hóa đơn xml để kiểm tra trực tiếp`,
	DeleteSuccess: 'Đã xóa thành công',
	RestoreSuccess: 'Khôi phục thành công',
	SystemDisplayDataToShow: {
		TextStart: 'Hệ thống hiển thị',
		TextEnd: 'kết quả giúp kiểm tra dữ liệu'
	},
	WrongExtension: 'Sai định dạng',
	Error: 'Lỗi',
	Giude: 'Hướng dẫn',
	ForwardMail: 'Chuyển tiếp thư',
	Col: 'Cột',
	AddSuccess: 'Thêm thành công',
	ErrorNeedContactMisa: 'Có lỗi xảy ra vui lòng liên hệ MISA để được trợ giúp',
	MISAError: 'Có lỗi xảy ra trong quá trình xử lý. Vui lòng liên hệ MISA để được hỗ trợ',
	MISAError1: 'Có lỗi xảy ra vui lòng liên hệ MISA để được trợ giúp',
	TaxCode: 'Mã số thuế',
	TaxCodeAndIdentification: 'Mã số thuế/CCCD chủ hộ',
	TaxCodeOrIdentification: 'MST hoặc CCCD chủ hộ',
	PlaceHolderSearchInfo: 'Nhập Mã số thuế/CCCD chủ hộ và nhấn để tìm kiếm',
	PlaceHolderTaxCodeSearch: 'Nhập Mã số thuế để tìm kiếm',
	CompanyName: 'Tên công ty',
	CompanyNameV2: 'Tên',
	IdentificationNumber: 'CCCD chủ hộ',
	CreateAccounting: 'Lập chứng từ',
	AttachStick: 'Gắn nhãn',
	FileAttach: 'Tệp đính kèm',
	PrintReceipt: 'In biên lai',
	PrintInvoice: 'In hóa đơn',
	PrintDeclaration: 'In tờ khai',
	invoice: 'hóa đơn',
	receipt: 'biên lai',
	Invoice: 'Hóa đơn',
	Receipt: 'Biên lai',
	ConfirmAccept: 'Bạn có muốn chấp nhận cho tất cả các lần sau không?',
	UpdateSuccess: 'Cập nhật thành công',
	KCT: 'thuế KCT',
	KKKNT: 'thuế KKKNT',
	CTTC: 'thuế CTTC',
	KTPVDC: 'thuế KTPVDC',
	KTGTT: 'thuế KTGTT',
	Rate0: 'thuế 0%',
	Rate5: 'thuế 5%',
	Rate8: 'thuế 8%',
	Rate10: 'thuế 10%',
	RateOther: 'thuế khác',
	AddAndCheck: 'Thêm & kiểm tra',
	SaveAndCheck: 'Lưu & kiểm tra',
	LimitCapacityFileAttach: 'Phần mềm chỉ hỗ trợ tệp đính kèm nhỏ hơn 5MB',
	ConfirmDeleteFileAttach: 'Bạn chắc chắn muốn xóa tệp đính kèm này không?',
	DeleteFileAttach: 'Xóa tệp đính kèm',
	DeleteFileAttachSuccess: 'Xóa tệp đính kèm thành công',
	DownloadFileAttachSuccess: 'Tải tệp đính kèm thành công',
	SelectTemplateInvoice: 'Chọn mẫu hóa đơn',
	Seller: 'Đơn vị bán hàng',
	SellerName: 'Tên đơn vị',
	OrganizationOrPayerName: 'Tên đơn vị hoặc người nộp tiền',
	SellerAddress: 'Địa chỉ',
	Address: 'Địa chỉ',
	BuyerName: 'Đơn vị mua hàng',
	TemplateNo: 'Mẫu số',
	Series: 'Ký hiệu',
	NumberInvoice: 'Số',
	InvoiceDate: 'Ngày hóa đơn',
	ReceiptDate: 'Ngày biên lai',
	StatementNo: 'Số bảng kê',
	StatementDate: 'Ngày bảng kê',
	LimitPeriod: 'Kỳ định mức',
	IncorrectInvoiceDate: 'Ngày hóa đơn sai sót',
	AccountingDate: 'Ngày hạch toán',
	RefNo: 'Số chứng từ',
	Accountor: 'Người hạch toán',
	Supplier: 'Nhà cung cấp',
	Item: 'Hàng hóa/Dịch vụ',
	BeforeTotalAmount: 'Tổng tiền trước thuế',
	VatAmount: 'Tiền thuế GTGT',
	TotalAmount: 'Tổng tiền thanh toán',
	TotalAmountSumary: 'Tổng tiền',
	Warning: 'Cảnh báo',
	EmailReceive: 'Email nhận hóa đơn',
	NoInvoice: 'Hóa đơn số',
	InvoiceNoted: 'Hóa đơn đã có ghi chú',
	SaveNoteSuccess: 'Lưu ghi chú thành công',
	ConditionSaveNoted: 'Vui lòng chọn ít nhất một hóa đơn muốn ghi chú',
	SuggestionsProblem: 'Hãy cho tôi biết vấn đề của bạn',
	BuyerInfo: 'Thông tin người mua',
	SellerInfo: 'Thông tin người bán',
	Signature: 'Chữ ký điện tử',
	SellerStatus: 'Tình trạng hoạt động của người bán',
	RiskStatus: 'Tình trạng rủi ro về thuế',
	NotiPublishInvoice: 'Hóa đơn thông báo phát hành',
	Other: 'Khác',
	SuggestionsInfoFeedback: 'Vui lòng chọn thông tin cần phản hồi',
	SendFeedbackForDevelopmentSuccess: 'Gửi phản hồi cho nhà phát triển thành công',
	ConfirmRemoveStick: 'Bạn chắc chắn muốn gỡ bỏ các nhãn đã chọn',
	SelectAll: 'Chọn tất cả',
	RemoveSelectAll: 'Bỏ chọn tất cả',
	Selected: 'Đã chọn',
	ClearSelection: 'Bỏ chọn',
	ForwardInvoiceSuccess: 'Chuyển hóa đơn/biên lai thành công',
	ForwardDeclarationSuccess: 'Chuyển tờ khai thành công',
	TotalNeedPayment: 'Tổng tiền cần thanh toán',
	SelectPaymentDate: 'Chọn ngày thanh toán',
	PaymentDate: 'Ngày thanh toán',
	Payer: 'Người thanh toán',
	AmountPayment: 'Số tiền thanh toán',
	AmountNotPayment: 'Số tiền chưa thanh toán',
	PaymentFull: 'Thanh toán toàn phần',
	PaymentPartial: 'Thanh toán một phần',
	PaymentNextDayPre: 'Ngày thanh toán tiếp theo sau',
	PaymentNextDay: 'Ngày thanh toán tiếp theo',
	Sended: 'Đã gửi',
	ExpressionInvoiceXML: 'Đây là bản thể hiện dựa trên nội dung XML của hóa đơn',
	ExpressionInvoiceXMLNoted: 'Nội dung này có thể không chính xác theo đúng biểu mẫu của hóa đơn đã phát hành',
	ItemDetail: {
		ItemName: 'Tên hàng hóa/Dịch vụ',
		UNITNAME: 'ĐVT',
		Quantity: 'Số lượng',
		UnitPrice: 'Đơn giá',
		DiscountRate: 'Tỷ lệ CK',
		DiscountRateFull: 'Tỷ lệ chiết khấu',
		DiscountAmount: 'Tiền chiết khấu',
		AmountWithoutVat: 'Thành tiền trước thuế',
		VatRate: 'Thuế suất',
		VatAmount: 'Tiền thuế',
		Amount: 'Thành tiền'
	},
	WarningInfo: {
		WarningExpired: 'Cảnh báo hết hạn',
		LicenseExpired: 'Tài nguyên của bạn đã hết hạn',
		CheckAgain: 'Vui lòng kiểm tra lại',
		WarningExpriedQuantityInvoice: 'Cảnh báo hết số lượng hóa đơn',
		OutOfQuantityInvoice: 'Bạn đã hết số lượng hóa đơn sử dụng',
		WarningDuplicareInvoice: 'Cảnh báo hóa đơn trùng',
		InvoiceNoDuplicate: 'Số hóa đơn trùng',
		DeclarationNoDuplicate: 'Số tờ khai trùng'
	},
	MISAInvoiceBot: 'MISA meInvoice - Xử lý hóa đơn',
	SaveTime80Per: 'Tiết kiệm 80% thời gian',
	AutoSearchAnalyze: 'Tự động tra cứu, phân tích và kiểm tra hóa đơn',
	StoreManage: 'Lưu trữ, quản lý hóa đơn tập trung',
	SyncAppAccounting: 'Đồng bộ với phần mềm kế toán và hạch toán',
	UseFullFeature: 'Để sử dụng đầy đủ tính năng, vui lòng',
	InfoForSupport: 'hoặc để lại thông tin để được tư vấn thêm',
	FullName: 'Họ tên',
	PhoneNumber: 'Số điện thoại',
	InputResultEmail: 'Nhập email nhận kết quả kiểm tra hóa đơn',
	ReceiveResult: 'Nhận kết quả',
	UnSendCheckingResultContactMISA: 'Không gửi được kết quả kiểm tra hóa đơn. Vui lòng liên hệ MISA để được hỗ trợ',
	OptionOfYou: 'Ý kiến của bạn',
	ConditionNPS: 'Bạn cần chấm điểm mức độ hài lòng trước khi gửi phản hồi',
	CopySuccess: 'Sao chép thành công',
	NotificationSendMail: email =>
		`Hóa đơn đã được gửi vào mail <span style="color: #00aab7">${email}</span> của quý khách`,
	ReasonNPS: {
		ReasonNPS1: 'Sản phẩm không đáp ứng nhu cầu',
		ReasonNPS2: 'Sản phầm hay bị lỗi',
		ReasonNPS3: 'Dịch vụ tư vấn hỗ trợ khách hàng kèm',
		ReasonNPS4: 'Giá thành cao',
		ReasonNPS5: 'Bảo mật phần mềm kém',
		ReasonNPS6: 'Tốc độ xử lý chậm',
		ReasonNPS7: 'Thao tác sử dụng không thuận tiện',
		ReasonNPS8: 'Lý do khác'
	},
	ApplicationProcessing: 'Hệ thống đang xử lí và sẽ trả về kết quả sau ít phút',
	Change: 'Thay đổi',
	Customer: 'Khách hàng',
	ContactMisaUpdateLatest: 'Vui lòng thực hiện kết nối để MISA giúp bạn tự động cập nhật hóa đơn nhanh nhất',
	InputCustomerNameAndInvoiceNo: 'Nhập tên khách hàng, số hóa đơn để tìm kiếm',
	InputSupplierNameAndInvoiceNo: 'Nhập Tên nhà cung cấp, Số hóa đơn để tìm kiếm',
	InputSupplierNameInvoiceNoAccount: 'Nhập Tên nhà cung cấp, Số hóa đơn và Tài khoản để tìm kiếm',
	ErrorTryAgain: 'Có lỗi xảy ra vui lòng thử lại',
	TwoFactorAuthentication: 'Xác thực 2 yếu tố',
	ReceiveAuthenticationCode: 'Nhận mã xác thực từ ứng dụng',
	SettingInDevice: 'mà bạn đã cài đặt trên thiết bị của bạn',
	AuthenticationCodeSend: 'Mã xác thực đã được gửi đến',
	phonenumber: 'số điện thoại',
	phone: 'điện thoại',
	CheckPlease: 'Vui lòng kiểm tra',
	InputAuthenticationCode: 'và nhập chính xác mã vào ô dưới',
	AuthenticationCode: 'Mã xác thực',
	NotQuestionDevice: 'Không hỏi lại thiết bị này',
	TryAnotherWay: 'Thử cách khác',
	TryReceiveAuthenticationCodeOther: 'Thử cách nhận mã xác thực khác',
	ReceiveAuthenticationCodeByEmail: 'Nhận mã xác thực qua email',
	ReceiveAuthenticationCodeByPhoneNumber: 'Nhận mã xác thực qua số điện thoại',
	YouSetting: 'mà bạn đã thiết lập',
	SendAgainAuthenticationCodeSuccess: 'Gửi lại mã xác thực thành công',
	ApplicationNotAutoDownloadMeinvoice: 'Hệ thống không tự động tải về hóa đơn được phát hành bởi',
	ForSaveLicense: 'để tiết kiệm tài nguyên',
	DownloadAllInvoiceInbotOfMeInvoice:
		'Tải toàn bộ hóa đơn đầu ra<br/> (bao gồm hóa đơn phát hành bởi <b>MISA meInvoice</b>)',
	AmisAccounting: 'AMIS Kế toán',
	Skip: 'Bỏ qua',
	Continue: 'Tiếp tục',
	Understood: 'Đã hiểu',
	AddSupplierNew: 'Thêm mới nhà cung cấp',
	ToDay: 'Hôm nay',
	InvoiceDownloadSuccess: 'Hóa đơn tải thành công',
	DeclarationUploadSuccess: 'Tờ khai tải thành công',
	MonthInfo: {
		January: 'Tháng 1',
		February: 'Tháng 2',
		March: 'Tháng 3',
		April: 'Tháng 4',
		May: 'Tháng 5',
		June: 'Tháng 6',
		July: 'Tháng 7',
		August: 'Tháng 8',
		September: 'Tháng 9',
		October: 'Tháng 10',
		November: 'Tháng 11',
		December: 'Tháng 12'
	},
	WeekDays: {
		Monday: 'T2',
		Tuesday: 'T3',
		Wednesday: 'T4',
		Thursday: 'T5',
		Friday: 'T6',
		Saturday: 'T7',
		Sunday: 'CN'
	},
	conditionmin: 'phải nhỏ hơn',
	conditionmax: 'phải lớn hơn',
	notinputempty: 'không được để trống',
	AlertPresentationXML: isReceipt =>
		`Đây là bản thể hiện dựa trên nội dung XML của ${isReceipt ? 'biên lai' : 'hóa đơn'}.`,
	AlertContentMaybeDifferentInvoice: isReceipt =>
		`Nội dung này có thể không chính xác theo đúng biểu mẫu của ${isReceipt ? 'biên lai' : 'hóa đơn'
		} đã phát hành.`,
	New: 'Mới',
	Activity: 'Hoạt động',
	SelectLimitOneYear: 'Chỉ được phép chọn tối đa 1 năm',
	SelectLimitYears: year => `Chỉ được phép chọn tối đa ${year} năm`,
	SelectLimitDays: number => `Chỉ được phép chọn tối đa ${number} ngày`,
	EachInvoiceWillSpendCost: 'Mỗi hóa đơn đầu ra đồng bộ về sẽ bị trừ tài nguyên giống như hóa đơn đầu vào.',
	FileXmlUploadInValidateTitle: 'Hóa đơn tải lên không hợp lệ',
	FileXmlUploadInValidate:
		'Mã số thuế người bán - mẫu số/ký hiệu - số hóa đơn trên file *xml, *inv tải lên khác với thông tin hóa đơn đã tồn tại trên chương trình.',
	FileXmlUploadFail: 'File hóa đơn XML tải lên thất bại',
	UploadFileXmlSuccess: 'Tải lên file xml thành công',
	SocialistRepublicVietnam: 'CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM',
	IndependentFreedomHappy: 'Độc lập - Tự do - Hạnh phúc',
	FileXmlUploadInvalidateFormat: 'File tải lên không đúng định dạng hóa đơn (*xml, *inv)',
	FilePdfUploadInvalidateFormat:
		'File tải lên không đúng định dạng hóa đơn (*pdf, *jpg, *jpeg, *jfif, *pjpeg, *pjp, *png, *apng, *gif, *bmp, *avif, *svg, *webp)',
	record: 'bản ghi',
	NextPage: 'Sau',
	PreviousPage: 'Trước',
	OrderNumber: 'STT',
	million: 'triệu',
	thousand: 'nghìn',
	billion: 'tỷ',
	trillion: 'nghìn tỷ',
	quadrillion: 'triệu tỷ',
	When: 'Lúc',
	Notification: 'Thông báo',
	MultipleDecentralization: 'Phân quyền hàng loạt',
	Day: 'Ngày',
	InputInvoice: 'Hóa đơn đầu vào',
	OutputInvoice: 'Hóa đơn đầu ra',
	supplier: 'NCC',
	ExistedNote: 'đã tồn tại ghi chú',
	Uploaded: 'Đã tải lên',
	at: 'lúc',
	UnPaymentInvoice: 'Bỏ đánh dấu thanh toán',
	Content: 'Nội dung',
	StartDate: 'Ngày bắt đầu',
	EndDate: 'Ngày kết thúc',
	SearchInvoice: 'Tra cứu',
	SearchingInvoice: 'Đang tra cứu',
	ErrorWarningCaptcha: 'Đã xảy ra lỗi trong quá trình kết nối, vui lòng kiểm tra lại',
	conditionminorequal: 'phải nhỏ hơn hoặc bằng',
	conditionmaxorequal: 'phải lớn hơn hoặc bằng',
	Option: 'Tùy chọn',
	Custom: 'Tùy chỉnh',
	Infomation: 'Thông tin',
	DefaultTemplate: 'Mẫu mặc định',
	ShortForm: 'Mẫu rút gọn',
	NotData: 'Không có dữ liệu',
	ViewGuide: 'Xem hướng dẫn',
	MarkViewed: 'Đánh dấu đã xem',
	MarkUnViewed: 'Đánh dấu chưa xem',
	NotTaxCodeForSearch: 'Không có thông tin MST người bán để tra cứu',
	NotFindRelaticeInvoice: 'Không tìm được hóa đơn liên quan trên hệ thống',
	ViewInfo: 'Xem thông tin',
	HiddenInfo: 'Ẩn thông tin',
	NumberDateNotifyValidate: 'Ngày nhắc trước hạn không được để trống',
	FeatureUnderDevelop: 'Tính năng đang phát triển.',
	ExperienceNow: 'Trải nghiệm ngay',
	AIAssistantMISA: 'Trợ lý số MISA AVA',
	ViewCriteriaExplain: 'Giải thích',
	MISARelease: `MISA meInvoice <span style="color: #00aab7">đã ra mắt</span>`,
	AIFeatureRelease: `<span class="font-bold">MISA AVA</span> trên MISA meInvoice có thể:`,
	HelpToUse: 'Trợ giúp, hướng dẫn sử dụng phần mềm',
	MonitorAndReport: 'Theo dõi, cung cấp các số liệu, báo cáo nhanh chóng',
	NaturalCommunication: 'Giao tiếp tự nhiên nhờ ứng dụng Chat GPT',
	FeatureCommingSoon: '...Và còn nhiều tính năng tuyệt vời đang tiếp tục cập nhật',
	AcceptTaxRates: 'Chấp nhận thuế suất',
	ExceedingLineLimit: 'Vượt quá số dòng cho phép',
	Translate: 'Dịch',
	ConnectUnAuthority: userName =>
		`Tài khoản ${userName} không có quyền tra cứu hóa đơn trên hệ thống của Cơ quan Thuế.`,
	NotPermissionAcceptResult:
		'Bạn không có quyền chấp nhận hợp lệ. Vui lòng liên hệ người dùng có quyền Quản trị để được phân quyền.',
	NotPermissionTitle: 'Không có quyền chấp nhận hợp lệ',
	CheckWidthTCT: 'Kiểm tra với hệ thống Cơ quan Thuế',
	Undefined: 'Chưa xác định',
	UndefinedStatus: isApplyNewLogic =>
		`Chưa xác định tình trạng hoạt động của người bán tại ${!isApplyNewLogic ? 'ngày hóa đơn' : 'ngày kiểm tra'}`,
	SellerActive: date => `Người bán đang hoạt động tại ngày ${date}`,
	SellerInactive: date => `Người bán ngừng hoạt động tại ngày ${date}`,
	SellerUndifinedStatus: date => `Chưa xác định tình trạng hoạt động của người bán tại ngày ${date}`,
	SellerWaitingUpdateIdentityCode: date => `Người bán chờ cập nhật CCCD tại ngày ${date}`,
	WaitingVerification: date => `Người bán chờ xác minh tình trạng hoạt động tại ngày ${date}`,
	SellerStatusDetail: (text, date) => `Người bán có tình trạng hoạt động là ${text} tại ngày ${date}`,
	InvalidCaptcha: 'Có lỗi hệ thống. Vui lòng kết nối lại hoặc liên hệ MISA để được hỗ trợ.',
	PermissionGuild: 'Hướng dẫn phân quyền sử dụng',
	TypeOfUploadInvoice: 'Các hình thức tải hóa đơn đầu vào lên phần mềm',
	TypeOfUploadInvoiceThirdParty: 'Các hình thức tải hóa đơn lên phần mềm',
	UpLoadFileInvoice: 'Tải lên tệp hóa đơn (*xml, *inv, *pdf) có sẵn',
	SendEmail: email => `Gửi hoặc chuyển tiếp hóa đơn điện tử đến email <span  style="cursor: pointer;color: #00A2CF">${email}</span>`,
	ConnectCQT: 'Kết nối với <span style="color: #DC6803;font-weight: 700;">Cơ quan Thuế</span> để tự động tải hóa đơn',
	ConnectNCC: 'Kết nối với nhà cung cấp để tự động tải hóa đơn',
	BtnConnectCQT: 'Kết nối CQT',
	BtnConnectNCC: 'Kết nối NCC',
	BtnSendEmail: 'Gửi email',
	TypeOfUploadOutInvoice: 'Các hình thức tải hóa đơn đầu ra lên phần mềm:',
	UploadFileOutInvoice: 'Tải lên tệp hóa đơn (*xml, *inv) có sẵn',
	PopularQuestion: 'Câu hỏi thường gặp',
	MinusResourceInvoice:
		'<b>Lưu ý:</b>&nbsp;Với mỗi hóa đơn đầu ra được đưa vào chương trình, bạn sẽ <b>&nbsp;bị trừ tài nguyên</b>.',
	MinusResourceDeclaraiton:
		'<b>Lưu ý:</b>&nbsp;Với mỗi tờ khai được đưa vào chương trình, bạn sẽ <b>&nbsp;bị trừ tài nguyên</b>.',
	UploadDeclaration: 'Tải lên tệp tờ khai (*xls, *xlsx, *xml) có sẵn',
	TypeOfUploadDeclaration: 'Hình thức tải tờ khai hải quan lên phần mềm:',
	ClickTo: 'Nhấn để',
	Click: 'Nhấn',
	toCheckAgain: 'để kiểm tra lại',
	checkAgain: 'kiểm tra lại',
	InvalidCaptcha: 'Có lỗi hệ thống. Vui lòng kết nối lại hoặc liên hệ MISA để được hỗ trợ.',
	PermissionGuild: 'Hướng dẫn phân quyền sử dụng',
	InvalidDateNoDownload: date => `Vui lòng chọn thời gian sau ngày ${date} với trạng thái Chưa tải được.`,
	AcceptText: 'Chấp nhận',
	Explain: 'Explain',
	HelpfulReview: 'Đánh giá hữu ích',
	NotHelpfulReview: 'Đánh giá không hữu ích',
	ViewFilmInstruction: 'Xem video hướng dẫn',
	SettingConnectTax: 'Thiết lập kết nối với CQT',
	VND: 'Đơn vị tiền: Đồng Việt Nam',
	TourguideCostType:
		'Bạn cần thiết lập Định mức chi phí theo thời gian trước khi xem báo cáo. Vui lòng truy cập vào <b>Hệ thống/Tùy chọn</b> để thiết lập định mức chi phí theo thời gian.',
	ContaxWithMisa: 'Có lỗi xảy ra, vui lòng liên hệ MISA để được trợ giúp.',
	LookupCQT: 'Dữ liệu được tra cứu, cập nhật liên tục từ nhiều nguồn như Cơ quan Thuế.',
	UpdateDBHC: 'Cập nhật địa giới hành chính',
	UpdateDBHCDetail:
		'Kết quả kiểm tra địa chỉ người mua, người bán trên hàng loạt hóa đơn có thể ảnh hưởng do việc sắp xếp địa giới hành chính cấp Huyện, Xã theo Nghị quyết số 35/2023/UBTVQH15.',
	ViewGuideDetail: 'Xem chi tiết hướng dẫn',
	NotRestoreDeclaration: 'Bạn không thể khôi phục tờ khai.',
	StatusInvoiceNew: 'hóa đơn mới',
	StatusInvoiceAdjusted: 'hóa đơn bị điều chỉnh',
	StatusInvoiceReplaced: 'hóa đơn bị thay thế',
	ContinueSave: 'Tiếp tục lưu',

	// BỔ SUNG: Keys cho combobox view info
	ViewAllInvoices: 'Xem tất cả hóa đơn',
	ViewSelectedInvoices: 'Chỉ xem hóa đơn được chọn',
	InvalidTaxCode: 'Mã số thuế không đúng định dạng. Vui lòng kiểm tra lại.',
	SetupNow: 'Thiết lập ngay',
	CannotFindData: 'Không tìm thấy dữ liệu',
	FilterAgain: 'Vui lòng kiểm tra lại điều kiện lọc để tìm dữ liệu của bạn',
	FilterUserSettingAgain: 'Không tìm thấy thông tin người dùng theo điều kiện tìm kiếm, vui lòng thử lại',
	FilterLayoutAgain: 'Không tìm thấy cột theo điều kiện tìm kiếm, vui lòng thử lại',
	SelectAtleastCretial: 'Vui lòng chọn ít nhất 1 dòng Tên tiêu chí trước khi nhấn <strong>Đồng ý</strong>',
	ViewAllDeclarations: 'Xem tất cả tờ khai',
	ViewSelectedDeclarations: 'Chỉ xem tờ khai được chọn',
	NoServiceProviderFound: 'Không tìm thấy nhà cung cấp hàng hóa dịch vụ',
	NoLicenseInfo: 'Vui lòng mua tài nguyên để sử dụng MISA meInvoice - Xử lý hóa đơn',
	DownloadFileError: 'Đã xảy ra lỗi hệ thống, vui lòng thử lại sau.',
	NoSubscriber: 'Không lấy được thông tin đơn vị, vui lòng thử lại sau.',
	pagingText: 'Số dòng/trang',
	ProcessingResult: 'Đang xử lý kết quả',
	FieldName: 'Tên trường',
	ApplyText: 'Áp dụng',

	// Keys cho confirm thoát form nhập liệu
	ExitConfirmTitle: 'Bạn muốn thoát mà không lưu?',
	ExitConfirmContent: 'Nếu bạn thoát, các dữ liệu đang nhập sẽ không được lưu lại.',
	StayOnForm: 'Ở lại',
	ExitWithoutSaving: 'Thoát, không lưu',
	NoPermissionTitle: 'Không có quyền thực hiện chức năng',
	NoPermissionFunctionTitle: 'Không có quyền thực hiện tính năng',
	NoPermissionPartTitle: 'Không có quyền',
	NoPermissionContactAdmin: 'Vui lòng liên hệ với người dùng có quyền quản trị để được xử lý.',
	NoPermissionSyncInput: 'Bạn không có quyền đồng bộ hóa đơn đầu vào. Vui lòng <b>bỏ tích chọn “Hóa đơn đầu vào”</b> để tiếp tục.<br/>Để được cấp đầy đủ quyền đồng bộ hóa đơn, hãy liên hệ với người dùng có quyền quản trị để được xử lý.',
	NoPermissionSyncOutput: 'Bạn không có quyền đồng bộ hóa đơn đầu ra. Vui lòng <b>bỏ tích chọn “Hóa đơn đầu ra”</b> để tiếp tục.<br/>Để được cấp đầy đủ quyền đồng bộ hóa đơn, hãy liên hệ với người dùng có quyền quản trị để được xử lý.',
	SelectFile: 'Chọn tệp'
};